import { api } from '../lib/api.js';

/**
 * The Prism account games see (`settings.account`): `{ id, username, token }` of
 * the signed-in person. The website answers with its own session; the desktop
 * app with the account it is signed in to. Fetched once and shared by every view.
 */
export interface GameAccount {
  id: number;
  username: string;
  token?: string;
}

let cached: GameAccount | null = null;
let pending: Promise<GameAccount | null> | null = null;

export function gameAccount(): Promise<GameAccount | null> {
  pending ??= api
    .get<{ account: GameAccount | null }>('/account/game-identity')
    .then((r) => (cached = r.account ?? null))
    .catch(() => null);
  return pending;
}

/** What is known right now (null until the first answer). */
export function currentGameAccount(): GameAccount | null {
  return cached;
}

/** After signing in or out: the next view asks again. */
export function resetGameAccount(): void {
  cached = null;
  pending = null;
}
